import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getTermNameToWeekList as _getTermNameToWeekList, getWeekList as _getWeekList, updateWeekInfoBySchool } from '@data/other';
export default {
  name: 'week-list',

  /*props: {
      configVo: {
          type: Object,
          default: function () {
              return {}
          }
      }
  },*/
  data: function data() {
    return {
      queryVo: {
        termName: '',
        pageNo: 1,
        pageSize: 15
      },
      weekListDao: {
        list: [],
        rowCount: 0
      },
      formLabelWidth: '100px',
      stepNum: 1,
      weekDay: -1,
      upWeekInfoVisible: false,
      // 周月份修改是否展示弹出框
      maxBelongsMonth: 0,
      minBelongsMonth: 0,
      currentWeek: {},
      updateWeekForm: {
        id: '',
        belongsMonth: ''
      }
    };
  },
  methods: {
    covertTime: function covertTime(str) {
      if (str === null || str === undefined || str === '') {
        return '';
      } else {
        return str.substring(0, 10);
      }
    },
    getTermNameToWeekList: function getTermNameToWeekList() {
      var self = this;

      _getTermNameToWeekList({}).then(function (res) {
        (res.termNameList || []).forEach(function (item) {
          self.queryVo.termName = item.termName;
        });

        if (self.queryVo.termName !== '') {
          self.getWeekList(1);
        }
      }).catch(function () {});
    },
    getWeekList: function getWeekList(type) {
      var self = this;

      if (type === 1) {
        self.queryVo.pageNo = 1;
      }

      _getWeekList(self.queryVo).then(function (res) {
        self.weekListDao = res.data;
      }).catch(function () {
        self.weekListDao = {
          list: [],
          rowCount: 0
        };
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryVo.pageNo = val;
      this.getWeekList();
    },
    updateWeekShow: function updateWeekShow(row) {
      var self = this;
      self.stepNum = 1; // if 判断   截取后台返回的月份与所属月份做比较 如果是修改到了后月份则只能减小    其中判断1月是后一个月 上个月为12 开始

      if (row.endTime.substring(5, 7) === (row.belongsMonth.length > 1 ? row.belongsMonth : '0' + row.belongsMonth)) {
        if (row.belongsMonth === '1') {
          self.weekDay = 12;
        } else {
          self.weekDay = row.belongsMonth - 1;
        }
      } else {
        self.weekDay = row.belongsMonth * 1;
      } // 结束


      self.currentWeek = row;
      self.updateWeekForm.id = row.id;
      self.updateWeekForm.belongsMonth = row.belongsMonth * 1;

      if (self.weekDay * 1 !== 12) {
        self.minBelongsMonth = self.weekDay;
        self.maxBelongsMonth = self.weekDay + 1;
      } else {
        self.minBelongsMonth = 1;
        self.maxBelongsMonth = 12;
        self.stepNum = 11;
      }

      self.upWeekInfoVisible = true;
    },
    handleMonthChange: function handleMonthChange(value) {
      var self = this;

      if (value == 13) {
        self.minBelongsMonth = 1;
        self.maxBelongsMonth = 12;
        self.stepNum = 11;
        self.updateWeekForm.belongsMonth = 1;
      }
      /* // minusMonth 设定当前月份减一，注意只有周跨月且当前设定的日期偏大月份时能减
      this.updateWeekForm.belongsMonth = parseInt(this.updateWeekForm.belongsMonth) - 1;
      // addMonth 设定当前月份加一，注意只有周跨月且当前设定的日期最小时能加，范围最多不超过一个月
      this.updateWeekForm.belongsMonth = parseInt(this.updateWeekForm.belongsMonth) + 1; */

    },
    saveWeekInfo: function saveWeekInfo() {
      var self = this;
      updateWeekInfoBySchool(self.updateWeekForm).then(function () {
        self.$notify.success('保存成功！');
        self.upWeekInfoVisible = false;
        self.getWeekList(1);
      }).catch(function () {});
    }
  },
  beforeMount: function beforeMount() {
    this.getTermNameToWeekList();
  }
};